module.exports = __webpack_public_path__ + "img/hotdog-top-ma001-old.6ced5de8.jpg";